import TypoGraphy from '@/typography';
import useViewType from '@/utils/Hooks/useViewType';
import React from 'react';
import './index.scss';
interface Props {
  count: number;
}
const PlusReviewerImage = ({
  count
}: Props) => {
  const isMobile = useViewType();
  return <div className="plus_reviwers" data-sentry-component="PlusReviewerImage" data-sentry-source-file="index.tsx">
        <TypoGraphy text={`+${count}`} variant={isMobile ? 'Desktop/Body 2/R | 14 |120' : 'Desktop/Body 1/R | 16 |120'} color='white' data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
    </div>;
};
export default PlusReviewerImage;